export enum CommonNumberMagicEnum {
	ZERO = 0,
	ONE = 1,
	EIGHT = 8,
	HUNDRED = 100,
}
